import React from 'react';
import { translate } from 'translations/i18n';
import PromoModal from 'components/shared/PromoModal';

const PAGE_TEMPLATES_YOUTUBE_URL = 'https://youtu.be/ziYtsT9c1Ys';

const SignaturesPromoModal = ({
  onRequestClose,
}: {
  onRequestClose: () => void;
}) => {
  return (
    <PromoModal
      onRequestClose={onRequestClose}
      videoUrl={PAGE_TEMPLATES_YOUTUBE_URL}
      titleText={translate('projectPage.templatePaywallModalTitle')}
      messageText={translate('projectPage.templatePaywallMessage')}
      features={[
        translate('projectPage.templatePaywallModalChecklist.one'),
        translate('projectPage.templatePaywallModalChecklist.two'),
        translate('projectPage.templatePaywallModalChecklist.three'),
      ]}
    />
  );
};

export default SignaturesPromoModal;
